import React from 'react';
import { useTranslation } from 'react-i18next';
import { middle } from '../../../../copy/ecap/classesSetupCopy.json';
import { getAcademicYearTitles } from '../../../../copy/ecap/classesSetupStrings';

export default function ColumnTitles() {
  const { t } = useTranslation();

  // Get all the years/levels of education
  const getColumnTitle = () => {
    const columnTitles = getAcademicYearTitles().map((year, index) => {
      return (
        <div className="year-title-container" key={year}>
          <p className="year-title-header">{`Year ${index + 1}`}</p>
          <p className="year">{`(${year})`}</p>
        </div>
      );
    });

    return columnTitles;
  };

  const getClassListTitle = () => {
    return (
      <p className="class-list-title-text" key="class-list">
        {t('Class List')}
      </p>
    );
  };

  return (
    <div className="column-titles">
      {getColumnTitle()}
      {getClassListTitle()}
    </div>
  );
}
